import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { MinimumsLayout } from '../Layout';

function MinimumsTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const finalLayout = useMemo(() => {
        return MinimumsLayout;
    }, []);

    const receiptOptions = [
        { id: 'A', text: 'After Item Charges' },
        { id: 'B', text: 'After Transaction Charges' },
        { id: 'C', text: 'After Both Item and Transaction Charges' },
    ];

    const shipmentOptions = [
        { id: 'A', text: 'After Item Charges' },
        { id: 'B', text: 'After Transaction Charges' },
        { id: 'C', text: 'After Both Item and Transaction Charges' },
    ];

    const handleMinimumsFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("APPLY_RECEIPT", receiptOptions);
            loadLookupClient("APPLY_SHIPMENT", shipmentOptions);
        }, 100);
    }, [loadLookupClient]);

    useEffect(() => {
        loadLookupClient("APPLY_RECEIPT", receiptOptions);
        loadLookupClient("APPLY_SHIPMENT", shipmentOptions);
    }, [loadLookupClient, props.formFields?.APPLY_RECEIPT, props.formFields?.APPLY_SHIPMENT]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='B3C7E4A1-9F52-4D8A-A1E3-7C6D2F8B5E90'
                layoutName='WMRateScheduleCodeMinimumsForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleMinimumsFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(MinimumsTab);

